import { API_URL } from "../config";

// One call instead of two.
//
// While developing, React's StrictMode runs every page's "load the data" step
// twice, so each page asked the API for everything twice. Two parts of a page
// can also ask for the same list at the same moment. When a GET call to the API
// is already on its way and the very same call is made again, the second one
// waits for the first and gets a copy of its answer.
//
// Only reading (GET) is shared, only while the first call is still in flight,
// and only for the same address and the same signed-in person. Nothing is kept
// afterwards, so a later call always gets fresh data.

const inFlight = new Map();

const headerValue = (headers, name) => {
    if (!headers) return "";
    if (typeof Headers !== "undefined" && headers instanceof Headers) return headers.get(name) || "";
    const key = Object.keys(headers).find((item) => item.toLowerCase() === name.toLowerCase());
    return key ? String(headers[key]) : "";
};

export function installSharedRequests() {
    if (typeof window === "undefined" || !window.fetch || window.fetch.sharesRequests) return;

    const plainFetch = window.fetch.bind(window);

    const sharedFetch = (input, init = {}) => {
        const url = typeof input === "string" ? input : "";
        const method = String(init.method || "GET").toUpperCase();

        // Anything that is not a plain read of the API goes straight through.
        if (!url || !url.startsWith(API_URL) || method !== "GET" || init.signal || init.body) {
            return plainFetch(input, init);
        }

        const key = `${url}\n${headerValue(init.headers, "Authorization")}\n${headerValue(init.headers, "Accept")}`;

        let call = inFlight.get(key);
        if (!call) {
            call = plainFetch(input, init);
            inFlight.set(key, call);
            const forget = () => {
                if (inFlight.get(key) === call) inFlight.delete(key);
            };
            call.then(forget, forget);
        }

        // Each asker reads its own copy of the answer.
        return call.then((response) => response.clone());
    };

    sharedFetch.sharesRequests = true;
    window.fetch = sharedFetch;
}
